import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserPermissionService } from '../services/user-permission-service';
import Global from '../store/global-selectors';
import { ActiveSubscriptionRequired } from '../components/active-subscription-required';

export const UserHasRole = ({ requiredPermissionRole, children }) => {
  const userRoles = useSelector(Global.selectUseruserRoles);
  const useHasRequiredRole = UserPermissionService.userIsInRoleOrHasAdministrationPermission(userRoles, requiredPermissionRole);

  return useHasRequiredRole ? (
    children
  ) : (
    <Redirect
      to={{
        pathname: UserPermissionService.getFirstPermissableRouteUrl(userRoles),
      }}
    />
  );
};

UserHasRole.propTypes = {
  requiredPermissionRole: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export const UserHasRoleAndSubscription = ({ requiredPermissionRole, children }) => {
  return (
    <ActiveSubscriptionRequired>
      <UserHasRole requiredPermissionRole={requiredPermissionRole}>{children}</UserHasRole>
    </ActiveSubscriptionRequired>
  );
};

UserHasRoleAndSubscription.propTypes = {
  requiredPermissionRole: PropTypes.string,
  children: PropTypes.node.isRequired,
};

// This component is deprecated in router v6.
// NOTE: To replicate this pattern of wrapping a route in some custom logic,
//       the wrapping component must accept a path prop aligning with the regex matching that react router uses.
//       This is because switch only looks at it's immediate children to do it's job.
const RoleBasedRoute = ({ component: Component, requiredPermissionRole, ...rest }) => {
  const userRoles = useSelector(Global.selectUseruserRoles);
  const isSubscriptionExpired = useSelector(Global.selectSellerIsSubscriptionExpired);
  const hasAccessToRoute = UserPermissionService.userIsInRoleOrHasAdministrationPermission(userRoles, requiredPermissionRole);
  const isSysAdmin = UserPermissionService.userIsSystemAdministrator(userRoles);
  if (!isSysAdmin && isSubscriptionExpired) {
    return <Redirect to='/settings/payments' />;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (hasAccessToRoute) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: UserPermissionService.getFirstPermissableRouteUrl(userRoles),
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

RoleBasedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  requiredPermissionRole: PropTypes.string,
  location: PropTypes.object,
};

export default RoleBasedRoute;
